import { render, staticRenderFns } from "./nurseLogin.vue?vue&type=template&id=019b31e4&scoped=true&"
import script from "./nurseLogin.vue?vue&type=script&lang=js&"
export * from "./nurseLogin.vue?vue&type=script&lang=js&"
import style0 from "./nurseLogin.vue?vue&type=style&index=0&id=019b31e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b31e4",
  null
  
)

export default component.exports